"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApolloClient = void 0;
var client_1 = require("@apollo/client");
var isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
var createApolloClient = function (options) {
  if (options === void 0) {
    options = {};
  }
  return new client_1.ApolloClient(__assign({
    uri: process.env.GRAPHQL_SERVER,
    headers: {
      accesskey: process.env.GRAPHQL_ACCESS_KEY
    },
    connectToDevTools: true,
    cache: new client_1.InMemoryCache(),
    fetch: isomorphic_fetch_1.default
  }, options));
};
exports.createApolloClient = createApolloClient;